export default "__VITE_ASSET__BUtxbf3a__"